<template>
  <v-card
    elevation="1"
    class="rounded-lg d-flex flex-column align-center full-width pgm-dashboard-container claim-container"
    :ripple="false"
    :class="{ 'pa-4': !isMobile, 'pa-2': isMobile }"
  >
    <div class="d-flex justify-space-between align-center full-width mb-4">
      <Typography variant="h-3" class="text-left">{{
        $t("dashboardWidgets.claims.title")
      }}</Typography>
    </div>
    <div class="d-flex flex-column full-width text-left">
      <p v-if="!WidgetData?.length" class="text-center darkGrey--text1">
        {{ $t("dashboardWidgets.claims.empty") }}
      </p>
      <div v-for="(item, index) in WidgetData || []" :key="index" class="claim-row rounded">
        <div class="d-flex justify-space-between align-center">
          <span class="font-weight-bold text-body-1">{{ formatCustomTitle(item) }} </span>
          <!-- {{ item.createdAt }} -->
          <v-icon
            :title="item.reviewStatus"
            :color="
              item.reviewStatus === 'Pending'
                ? 'brandOrange'
                : item.reviewStatus === 'Needs More Info'
                ? 'warning'
                : item.reviewStatus === 'Approved'
                ? 'success'
                : 'red'
            "
            >{{
              item.reviewStatus === "Pending"
                ? "mdi-clock-outline"
                : item.reviewStatus === "Needs More Info"
                ? "mdi-alert"
                : item.reviewStatus === "Approved"
                ? "mdi-check-circle-outline"
                : "mdi-close-circle"
            }}</v-icon
          >
        </div>
        <div class="d-flex align-center text-caption mediumGrey--text">
          <span>{{ Program?.displayName }}</span>
        </div>
        <div class="d-flex align-center text-caption mediumGrey--text">
          <span v-if="item.reviewStatus === 'Approved' && item.payoutAmount > 0" class="mr-4">{{
            formatCurrency(item.payoutAmount, Award, true)
          }}</span
          ><span
            ><v-icon small class="mr-1">mdi-calendar</v-icon>{{ formatDate(item.createdAt) }}</span
          >
        </div>
      </div>
      <div class="d-flex justify-center">
        <Button
          color="brandPrimary"
          :disabled="previewMode"
          @click="$router.push('/claims')"
          :title="$t('dashboardWidgets.claims.goToClaims')"
          >{{ $t("dashboardWidgets.claims.goToClaims") }}
        </Button>
      </div>
    </div>
  </v-card>
</template>
<script>
import moment from "moment";

import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import formatCurrency from "@/mixins/formatCurrency.js";

export default {
  name: "Claim",
  components: {
    Typography,
    Button,
  },
  props: {
    config: {
      type: Object,
      required: true,

      // Developer note:
      // This schema is for readability - it doesn't actually restrict anything on the Vue side
      title: {
        type: Object,
        required: true,
        value: {
          type: String,
          required: true,
        },
        label: {
          type: String,
          required: true,
        },
      },
    },
    widgetData: {
      type: Array,
      required: false,
    },
    data: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    programData: {
      type: Object,
      required: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {},
  mixins: [formatCurrency],
  methods: {
    formatDate(date) {
      return moment(date).format("MMM D");
    },
    formatCustomTitle(item) {
      try {
        if (this.previewMode) {
          return "Reams of paper";
        }

        return (
          item[this.config?.title?.value || "displayName"] ||
          item?.claimDependencies?.displayName ||
          this.$t("dashboardWidgets.claims.unknownTitle", {
            label: this.config?.title?.label || "",
          })
        );
      } catch (e) {
        console.log("Error formatting custom title", e);
        return "";
      }
    },
  },
  computed: {
    WidgetData() {
      if (this.previewMode) {
        return [{ payoutAmount: 5, reviewStatus: "Pending", createdAt: "2025-05-24" }];
      } else {
        return this.data || this.widgetData || [];
      }
    },
    Program() {
      if (this.previewMode) {
        return { displayName: "Paper Sales 2025" };
      } else {
        return this.programData || {};
      }
    },
    Award() {
      return (this.programData && this.programData.Budget && this.programData.Budget.Award) || null;
    },
  },
};
</script>
<style scoped>
.claim-container {
  width: 100%;
  height: auto;
}

.claim-row {
  padding: 8px;
  background-color: var(--v-grey-lighten2);
  margin-bottom: 12px;
  /* border: 1px solid #e0e0e0;
  border-radius: 5px; */
}

/* Removes the grey shadow when clicking a card */
.v-card--link:before {
  background: none;
}
</style>
